import * as React from "react";
import { Context } from "./_context";
export const EmployerIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19.602 3.005A1 1 0 0 1 20.5 4v16a1 1 0 0 1-1 1h-15a1 1 0 0 1-1-1V4l.005-.103A1 1 0 0 1 4.5 3h15l.102.005ZM5.5 19H9v-3l.005-.102A1 1 0 0 1 10 15h4l.102.005A1 1 0 0 1 15 16v3h3.5V5h-13v14Zm5.5 0h2v-2h-2v2Z", fill: "currentColor" }));
  return iconset[size];
};
EmployerIcon.iconId = "H0JbP4";
